import React, { Component } from 'react';
import './savedcoursestyle.css';


const baseURL = 'https://www.youtube.com/embed/';


class SavedCoursePlayer extends Component {
state = {
    comments: [
        {commentId: 0, commentAuthor: "Sam" ,comment: "blablablablablablabla", commentDate: '2 Days Ago'},
        {commentId: 1, commentAuthor: "Jason" ,comment: "blablablablablablabla", commentDate: 'Yesterday'},
        {commentId: 2, commentAuthor: "Jenny" ,comment: "blablablablablablabla", commentDate: '4 Days Ago'}
    ]
}    

render() {
    console.log(this.props);
    const courseFinalId = this.props.location.pathname.slice(3);
    return(
        <div>
            <div className="SavedCourses">
                <iframe title="course player" src={baseURL + courseFinalId} />
            </div>

            <div className="CommentsContainer">
            <h2 style={{textAlign: 'center'}}>Comments</h2>
                {(this.state.comments).map(comment=>{
                    return(
                        <div key={comment.commentId} className="Comment">
                        <div className="Content">
                        <h4 className="Author">{comment.commentAuthor}</h4>
                        <p className="Date">{comment.commentDate}</p>
                        <p>{comment.comment}</p>
                    </div>
                </div>
                )})}
                

            <div>
                <button>Add Comment</button>
            </div>

            </div>

        </div>
    )      
}
}


export default SavedCoursePlayer;